import React from 'react';
import { MoreVertical, QrCode, Link2, ExternalLink, FileDown, Pencil, Files, Send, Trash2, Loader2 } from 'lucide-react';
import DropdownMenu from '../ui/DropdownMenu';
import styles from './EventActionsMenu.module.css';

// Shared dropdown menu for an event card/table row (Dashboard, EventsPage).
// Card view passes onQr/onCopyLink/onOpenEvent as top shortcuts; table view
// (which has these as separate visible controls already) omits them.
export default function EventActionsMenu({
    event,
    onEdit,
    onDelete,
    onDuplicate,
    onTransfer,
    onExportCsv,
    deletingId,
    exportingEventId,
    duplicatingId,
    triggerClassName,
    onQr,
    onCopyLink,
    onOpenEvent,
}) {
    return (
        <DropdownMenu
            align="right"
            aria-label="Event actions"
            trigger={
                <button
                    type="button"
                    className={triggerClassName || styles.menuTrigger}
                    title="Actions"
                    aria-haspopup="menu"
                    aria-label="Event actions"
                >
                    <MoreVertical size={16} />
                </button>
            }
        >
            {onQr && <DropdownMenu.Item icon={QrCode} onClick={onQr}>QR Code</DropdownMenu.Item>}
            {onCopyLink && <DropdownMenu.Item icon={Link2} onClick={onCopyLink}>Copy link</DropdownMenu.Item>}
            {onOpenEvent && <DropdownMenu.Item icon={ExternalLink} onClick={onOpenEvent}>Open event</DropdownMenu.Item>}
            {(onQr || onCopyLink || onOpenEvent) && <DropdownMenu.Divider />}
            {event.hasResponses && onExportCsv && (
                <DropdownMenu.Item
                    icon={exportingEventId === event.id ? Loader2 : FileDown}
                    disabled={exportingEventId === event.id}
                    onClick={() => onExportCsv(event)}
                >
                    {exportingEventId === event.id ? (
                        <><Loader2 size={14} className={styles.spin} /> Exporting…</>
                    ) : (
                        'Export'
                    )}
                </DropdownMenu.Item>
            )}
            {event.hasResponses && onExportCsv && <DropdownMenu.Divider />}
            <DropdownMenu.Item icon={Pencil} onClick={() => onEdit(event)}>Edit event</DropdownMenu.Item>
            <DropdownMenu.Item
                icon={duplicatingId === event.id ? Loader2 : Files}
                disabled={duplicatingId === event.id}
                onClick={() => onDuplicate(event)}
            >
                {duplicatingId === event.id ? (
                    <><Loader2 size={14} className={styles.spin} /> Duplicating…</>
                ) : (
                    'Duplicate'
                )}
            </DropdownMenu.Item>
            <DropdownMenu.Item icon={Send} onClick={() => onTransfer(event)}>Transfer</DropdownMenu.Item>
            <DropdownMenu.Divider />
            <DropdownMenu.Item
                icon={Trash2}
                danger
                disabled={deletingId === event.id}
                onClick={() => onDelete(event.id)}
            >
                {deletingId === event.id ? (
                    <><Loader2 size={14} className={styles.spin} /> Deleting…</>
                ) : (
                    'Delete event'
                )}
            </DropdownMenu.Item>
        </DropdownMenu>
    );
}
